var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadRecords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1885_3503)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#EA3E23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9444 16.0612H19.3562C20.133 16.0612 20.521 16.0612 20.7624 15.8198C21.0037 15.5784 21.0037 15.1905 21.0037 14.4137V13.5899C21.0037 12.0363 21.0037 11.2604 20.521 10.7776C20.0383 10.2949 19.2623 10.2949 17.7087 10.2949H10.295C8.7414 10.2949 7.96543 10.2949 7.48272 10.7776C7 11.2604 7 12.0363 7 13.5899V15.2374C7 15.6254 7 15.8198 7.12027 15.9409C7.24136 16.0612 7.43576 16.0612 7.82375 16.0612H9.05937",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47125 21.2562V14.4141C9.47125 13.6373 9.47125 13.2493 9.71261 13.008C9.95397 12.7666 10.342 12.7666 11.1187 12.7666H16.885C17.6618 12.7666 18.0498 12.7666 18.2911 13.008C18.5325 13.2493 18.5325 13.6373 18.5325 14.4141V21.2562C18.5325 21.5173 18.5325 21.6474 18.4468 21.7092C18.3611 21.771 18.2376 21.7298 17.9905 21.6474L16.2046 21.0519C16.1593 21.0325 16.1112 21.0208 16.0621 21.0173C16.013 21.0235 15.9654 21.038 15.9212 21.0601L14.1551 21.7669C14.1072 21.7913 14.0553 21.8066 14.0019 21.8122C13.9484 21.8066 13.8965 21.7913 13.8487 21.7669L12.0825 21.0601C12.0385 21.0382 11.9912 21.0237 11.9425 21.0173C11.8931 21.0206 11.8446 21.0323 11.7992 21.0519L10.0133 21.6474C9.76615 21.7298 9.64259 21.771 9.55692 21.7092C9.47125 21.6474 9.47125 21.5173 9.47125 21.2562Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9425 16.0605H15.2375M11.9425 18.5318H16.0612",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5325 10.295V9.96549C18.5325 8.56759 18.5325 7.86823 18.0984 7.43412C17.6643 7 16.9649 7 15.567 7H12.4367C11.0388 7 10.3395 7 9.90537 7.43412C9.47125 7.86823 9.47125 8.56759 9.47125 9.96549V10.295",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#11B50C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.78 13.159C17.6394 13.0185 17.4488 12.9397 17.25 12.9397C17.0512 12.9397 16.8606 13.0185 16.72 13.159L14.75 15.129V7.75C14.75 7.55109 14.671 7.36032 14.5303 7.21967C14.3897 7.07902 14.1989 7 14 7C13.8011 7 13.6103 7.07902 13.4697 7.21967C13.329 7.36032 13.25 7.55109 13.25 7.75V15.129L11.28 13.159C11.1378 13.0265 10.9498 12.9544 10.7555 12.9578C10.5612 12.9613 10.3758 13.04 10.2384 13.1774C10.101 13.3148 10.0223 13.5002 10.0188 13.6945C10.0154 13.8888 10.0875 14.0768 10.22 14.219L13.47 17.469L14 18L14.53 17.47L17.78 14.22C17.8497 14.1504 17.905 14.0676 17.9427 13.9766C17.9804 13.8856 17.9998 13.788 17.9998 13.6895C17.9998 13.591 17.9804 13.4934 17.9427 13.4024C17.905 13.3114 17.8497 13.2287 17.78 13.159ZM8.5 15.75C8.5 15.5511 8.42098 15.3603 8.28033 15.2197C8.13968 15.079 7.94891 15 7.75 15C7.55109 15 7.36032 15.079 7.21967 15.2197C7.07902 15.3603 7 15.5511 7 15.75V19C7 19.5304 7.21071 20.0391 7.58579 20.4142C7.96086 20.7893 8.46957 21 9 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V15.75C21 15.5511 20.921 15.3603 20.7803 15.2197C20.6397 15.079 20.4489 15 20.25 15C20.0511 15 19.8603 15.079 19.7197 15.2197C19.579 15.3603 19.5 15.5511 19.5 15.75V19C19.5 19.1326 19.4473 19.2598 19.3536 19.3536C19.2598 19.4473 19.1326 19.5 19 19.5H9C8.86739 19.5 8.74021 19.4473 8.64645 19.3536C8.55268 19.2598 8.5 19.1326 8.5 19V15.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1885_3503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadRecords);
export default __webpack_public_path__ + "static/media/download-records.3ed8f29ec709a3bed7fe0cb1bbe96454.svg";
export { ForwardRef as ReactComponent };